import React from 'react';
import {
  Formik,
  Field,
} from 'formik';
import {
  DateTime,
} from 'luxon';

import {
  Select,
  Button,
  DatePickerField,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

const selectProps = {
  styles: {
    container: provided => ({
      ...provided,
      width: '100%',
    }),
    menu: provided => ({
      ...provided,
      marginTop: '1px',
    }),
  },
  theme: theme => ({
    ...theme,
    borderRadius: 3,
  }),
};

type Props = {
  startDate: string,
  clientId: string,
  workoutsOptions: any,
  onSubmit: { (): void },
  onCancel: { (): void },
};

const ScheduleWorkout = ({
  onSubmit,
  workoutsOptions,
  startDate,
  onCancel,
  clientId,
}: Props) => (
  <Formik
    initialValues={{
      client: clientId,
      start: DateTime.fromJSDate(startDate),
      end: DateTime.fromJSDate(startDate).plus({ hours: 1 }),
    }}
    onSubmit={onSubmit}
    enableReinitialize
  >
    {({
      values,
      handleSubmit,
      setFieldValue,
      handleBlur,
    }) => (
      <Flex
        column
        as="form"
        width="100%"
        onSubmit={(vals) => {
          handleSubmit(vals);
        }}
      >
        <Flex width="100%" column>
          <S.Label>
            Time
          </S.Label>
          <Flex spacing={10}>
            <Field
              name="start"
              dateFormat="MM/dd/yyyy   hh:mm a"
              showTimeSelect
              component={DatePickerField}
            />
            <Field
              name="end"
              dateFormat="MM/dd/yyyy   hh:mm a"
              showTimeSelect
              component={DatePickerField}
            />
          </Flex>
        </Flex>
        <Flex width="100%" column>
          <S.Label htmlFor="workout-select">
            Workout
          </S.Label>
          <Select
            {...selectProps}
            id="workout-select"
            value={workoutsOptions ? workoutsOptions.find(option => option.value === values.workout) || '' : ''}
            onChange={(option: Option) => setFieldValue('workout', option.value)}
            onBlur={handleBlur}
            name="workout"
            options={workoutsOptions}
          />
        </Flex>
        <S.Footer>
          <hr />
          <Flex
            width="100%"
            justify="space-between"
          >
            <Button
              ghost
              appearance="danger"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              appearance="primary"
              isDisabled={
                  !values.start
                  || !values.end
                  || !values.workout
                }
            >
              Schedule
            </Button>
          </Flex>
        </S.Footer>
      </Flex>
    )}
  </Formik>
);

export default ScheduleWorkout;
